export default __webpack_public_path__ + "static/media/page1.c92fd55c.png";